import { render, staticRenderFns } from "./UpdateDetail.vue?vue&type=template&id=2952d909&scoped=true&"
import script from "./UpdateDetail.vue?vue&type=script&lang=js&"
export * from "./UpdateDetail.vue?vue&type=script&lang=js&"
import style0 from "./UpdateDetail.vue?vue&type=style&index=0&id=2952d909&prod&scoped=true&lang=css&"
import style1 from "./UpdateDetail.vue?vue&type=style&index=1&id=2952d909&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2952d909",
  null
  
)

export default component.exports